import { AxiosError } from "axios";
import { client } from "api";
import { OrderComment } from "models/OrderComment";

export type GetOrderCommentsRequest = string;

export type GetOrderCommentsResponse = OrderComment[];

export const getOrderComments = (orderId: GetOrderCommentsRequest) =>
  client
    .get<GetOrderCommentsResponse>(`/order/${encodeURIComponent(orderId)}/comments`)
    .then((res) => res.data)
    .catch((e: AxiosError) => {
      // The backend answers 404 when the order has no work description. Treat as empty.
      if (e.response?.status === 404) {
        return [] as GetOrderCommentsResponse;
      }
      throw e;
    });
